// Deep link to the invoice inside QuickBooks Online (WQ-260819-01 B). QBO resolves the company
// from the viewer's own Intuit session; someone without QuickBooks access lands on Intuit's
// sign-in, which matches the intended flow ("view the full invoice / pay at Intuit"). Returns
// null until the invoice actually exists in QuickBooks - only a 'created' row carries a real
// qbInvoiceId, and linking a pending/failed row would 404 inside QuickBooks.
export function qbInvoiceUrl(inv) {
  if (!inv || inv.status !== 'created' || !inv.qbInvoiceId) return null;
  return `https://qbo.intuit.com/app/invoice?txnId=${encodeURIComponent(inv.qbInvoiceId)}`;
}
